import { type StateCreator } from "zustand";

import type { Airport, AirportState } from "./types";

const initState = {
  selectedAirport: { value: "", label: "" },
  destinationAirport: null,
};

export const createAirportState: StateCreator<
  AirportState,
  [["zustand/devtools", never]]
> = (set, get) => ({
  ...initState,

  airportActions: {
    setSelectedAirport: (airport: Airport) => {
      set(
        { selectedAirport: airport },
        undefined,
        "airport/setSelectedAirport",
      );
    },

    setDestinationAirport: (airport) => {
      set(
        { destinationAirport: airport },
        undefined,
        "airport/setDestinationAirport",
      );
    },

    resetState: () => set(initState),

    resetSelectedAirport: () => {
      set({ selectedAirport: { value: "", label: "" } });
    },
  },

  airportUtils: {
    generateSummaryText: () => get().selectedAirport.label,
  },
});
